var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('accordion',{staticClass:"mbooks-product-estratto",attrs:{"white-theme":true,"accordion-items":_vm.getAccordionItems()}})}
var staticRenderFns = []

export { render, staticRenderFns }